<div
  class="a"
  [style.--a-width]="largura"
  [style.--a-height]="altura"
  [style.--a-base-measure]="menorMedida"
>
  <div class="aa">
    <div class="aaa">
      <div class="aaaa"> {{ etiqueta?.nomeDoFornecedor }} </div>
    </div>
    <div class="aab">
      <div class="aaba">MASCARELLO CARROCERIAS<br> E ONIBUS LTDA</div>
      <div class="aabb">
        <div class="aabba"> PLANTA: </div>
        <div class="aabbb"> {{ etiqueta?.planta }} </div>
      </div>
    </div>
  </div>
  <div class="ab">
    <div class="aba">
      <div class="abaa">
        <div class="abaaa"> NFe: </div>
        <div class="abaab"> {{ etiqueta?.numNF }} </div>
      </div>
    </div>
    <div class="abb">
      <div class="abba"> {{ etiqueta?.volumesFaturados }} Volumes </div>
    </div>
  </div>
  <div class="ac">
    <div class="aca"> Material: </div>
    <div class="acb">
      <div class="acba">
        <app-barcode
          [data]="etiqueta?.codigoMaterialCliente || null"
          [config]="barcodeConfig"
        >
        </app-barcode>
        <div class="acbaa"> {{ etiqueta?.codigoMaterialCliente }} </div>
        <div class="acbaa"> {{ etiqueta?.descricaoMaterial }} </div>
      </div>

    </div>
  </div>
  <div class="ad">
    <div class="ada">
      <div class="adaa">
        <div class="adaaa"> Ordem Venda: </div>
        <div class="adaab">
          <app-barcode
            [data]="etiqueta?.codigoBarrasOrdemDeVenda || null"
            [config]="barcodeConfig"
          >
          </app-barcode>
          <div class="adaaba"> {{ etiqueta?.codigoBarrasOrdemDeVenda }} </div>
        </div>
      </div>
    </div>
    <div class="adb">
      <div class="adba">
        <app-barcode
          [data]="etiqueta?.codigoBarrasItemOrdemDeVenda || null"
          [config]="barcodeConfig"
        >
        </app-barcode>
        <div class="adbaa"> {{ etiqueta?.codigoBarrasItemOrdemDeVenda }} </div>
      </div>
    </div>
  </div>
  <div class="ae">
    <div class="aea">
      <div class="aeaa">
        <div class="aeaaa"> Lote: </div>
        <div class="aeaab">
          <app-barcode
            [data]="etiqueta?.loteMascarello || null"
            [config]="barcodeConfig"
          >
          </app-barcode>
          <div class="aeaaba"> {{ etiqueta?.loteMascarello }} </div>
        </div>
      </div>
    </div>
    <div class="aeb">
      <div class="aeba">
        <div class="aebaa"> Nº Carro </div>
        <div class="aebab"> {{ etiqueta?.loteMascarello }} </div>
      </div>
    </div>
  </div>
  <div class="af">
    <div class="afa">
      <div class="afaa">
        <div class="afaaa"> {{ etiqueta?.quantidadeMaterial }} </div>
        <div class="afaab"> {{ etiqueta?.unidadeMedidaFornecimento }} </div>
      </div>
      <div class="afab">
        <div class="afaba">
          <div class="afabaa"> Dep.: </div>
          <div class="afabab"> {{ etiqueta?.deposito }} </div>
        </div>
        <div class="afabb">
          <div class="afabba"> Pos. Dep.: </div>
          <div class="afabbb"> {{ etiqueta?.posicaoDeposito }} </div>
        </div>
      </div>
    </div>
    <div class="afb">
      <div class="afba"> Pedido: </div>
      <div class="afbb">
        <app-qr-code
          [data]="etiqueta?.qrCodPedidoEItemCodigoBarras || null"
          [config]="qrCodeConfig"
        >
        </app-qr-code>
        <div class="afbba"> {{ etiqueta?.qrCodPedidoEItemCodigoBarras }} </div>
      </div>
    </div>
  </div>
</div>
